import { render, staticRenderFns } from "./Diagram.vue?vue&type=template&id=23e7ebd8"
import script from "./Diagram.vue?vue&type=script&lang=js"
export * from "./Diagram.vue?vue&type=script&lang=js"
import style0 from "./Diagram.vue?vue&type=style&index=0&id=23e7ebd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports